import type {
  AggregateReportOptions,
  Aggregation,
  CreateManifestHistoryReportRequest,
  DownloadManifestHistoryReportRequest,
  DownloadManifestHistoryReportResponse,
} from './types';
import { getToken } from '../../session';
import GatewayAxiosClient from '../GatewayAxiosClient';
export class SiteReportingService {
  public async fetchAggregateReport(requestParams: AggregateReportOptions) {
    const { partnerId, startDate, endDate, timeDivider, selectedFulfillmentCenterId, serviceLevelReportingType } =
      requestParams;
    const res = await GatewayAxiosClient.get(
      `/reporting/partner/${partnerId}/aggregations/${serviceLevelReportingType}`,
      {
        params: {
          startDate: new Date(startDate).toISOString(),
          endDate: new Date(endDate).toISOString(),
          timeDivider,
          selectedFulfillmentCenterId,
        },
        headers: {
          authorization: getToken(),
        },
      },
    );
    if (!res.data.aggregations.length) {
      throw new Error('No data found');
    }
    return res.data.aggregations.map((agg: Aggregation) => ({
      ...agg,
      timeDivision: requestParams.timeDivider,
    }));
  }

  public async createManifestHistoryReport(requestParams: CreateManifestHistoryReportRequest) {
    const { partnerId, carrierId, countryCode, postalCode, tenantId, isTest } = requestParams;
    const res = await GatewayAxiosClient.post(
      `/reporting/partner/${partnerId}/manifest`,
      {
        carrierId,
        countryCode,
        postalCode,
        tenantId,
        isTest,
      },
      {
        headers: {
          authorization: getToken(),
        },
      },
    );

    return res.data;
  }

  public async downloadManifestHistoryReport(requestParams: DownloadManifestHistoryReportRequest) {
    const { carrierId, countryCode, postalCode, tenantId, isTest, manifestJobId, manifestId, partnerId } =
      requestParams;
    const res = await GatewayAxiosClient.post<DownloadManifestHistoryReportResponse>(
      `/reporting/partner/${partnerId}/manifest/download`,
      {
        carrierId,
        countryCode,
        postalCode,
        tenantId,
        manifestJobId,
        manifestId,
        testMode: isTest,
      },
      {
        headers: {
          authorization: `Bearer ${getToken()}`,
        },
      },
    );
    return res.data;
  }
}
